module.exports = __webpack_public_path__ + "static/img/concat_header.9a6090e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/concat/concat_header.png
// module id = wDjI
// module chunks = 1